<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Menus'
 * Name: 'MenuLegacyMarker'
 * FIGMA: ''
 */
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'

import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'MenuLegacyMarker',
})

const LEGACY_MARKER_TOOLTIP = 'Legacy page, need to move to new Admin Panel'
</script>

<template>
  <span class="legacy-marker">
    <AppTooltip
      :text="LEGACY_MARKER_TOOLTIP"
      placement="right"
      size="small"
    >
      <AppIcon
        :icon="faTriangleExclamation"
        size="small"
        color="amber-400"
      />
    </AppTooltip>
  </span>
</template>

<style lang="scss" scoped src="../styles/_menu-legacy-marker.scss" />
